// @flow
import type { Action, Alert } from '../types';
import * as constants from '../constants/alertConstants';

export type State = $ReadOnly<{
    list: $ReadOnlyArray<$PropertyType<Alert, 'id'>>,
    entities: $ReadOnly<{
        [id: string]: Alert
    }>,
    status: $ReadOnly<{
        isLoading: boolean,
        error: boolean
    }>
}>;

const initialState = {
    list: [],
    entities: {},
    status: {
        isLoading: false,
        error: false
    }
};
export default function alertsReducer(state: State = initialState, action: Action): State {
    switch(action.type) {
        case constants.LOAD_ALERTS: {
            const list = [];
            const entities = {};

            for(let i = 0, length = action.data.length; i < length; i += 1) {
                const alert = action.data[i];
                const id = alert.id;

                list.push(id);
                entities[id] = alert;
            }

            return {
                ...state,
                list,
                entities
            };
        }

        case constants.SET_ALERT: {
            const id = action.data.id;

            let list = state.list;
            if(list.indexOf(id) === -1) {
                list = [
                    ...list,
                    id
                ];
            }

            return {
                ...state,
                list,
                entities: {
                    ...state.entities,
                    [id]: action.data
                }
            };
        }

        case constants.UNSET_ALERT: {
            const id = action.data.id;

            let list = state.list;
            let isChanged = false;
            const index = list.indexOf(id);
            if(index !== -1) {
                isChanged = true;
                list = [].concat(list);
                list.splice(index, 1);
            }

            let entities = state.entities;
            if(state.entities[id]) {
                isChanged = true;
                entities = {
                    ...state.entities
                };
                delete entities[id];
            }

            if(!isChanged) {
                return state;
            }

            return {
                ...state,
                list,
                entities
            };
        }

        default:
            return state;
    }
}